// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606121003/js/" + chunkId + "." + {"44":"f117b1c4","225":"406b2d51","481":"f70dacb6","486":"af87782b","770":"ea37cabc"}[chunkId] + ".0.9800815928545082.chunk.js";
};